import React from 'react';
import { Card } from '../ui/card';
import { whoWeHelp } from '../../mockData';

const WhoWeHelpSection = () => {
  return (
    <section className="section-light">
      <div className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-lg mb-6">Who We Help</h2>
        </div>
        <div className="grid-3">
          {whoWeHelp.map((audience) => (
            <Card key={audience.id} className="premium-card">
              <h3 className="heading-md mb-3">{audience.title}</h3>
              <p className="body-md text-[var(--text-muted)] mb-4 italic">{audience.audience}</p>
              <div className="mb-6">
                <h4 className="font-semibold text-sm mb-3" style={{ color: 'var(--primary-navy)' }}>Common Challenges:</h4>
                <ul className="space-y-2">
                  {audience.painPoints.map((point) => (
                    <li key={point} className="text-sm text-[var(--text-muted)] flex items-start gap-2">
                      <span className="text-[var(--accent-sky)] mt-1">•</span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="pt-4 border-t border-[var(--border-color)]">
                <p className="body-md font-medium" style={{ color: 'var(--primary-navy)' }}>{audience.solution}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelpSection;
